import {
  List,
  Datagrid,
  Create,
  Edit,
  SimpleForm,
  DateInput,
  RichTextField,
  DateField,
} from 'react-admin'
import { RichTextInput } from 'ra-input-rich-text'

export const ListReleases = () => (
  <List>
    <Datagrid rowClick="edit" bulkActionButtons={false}>
      <RichTextField source="description" />
      <DateField source="released_at" />
    </Datagrid>
  </List>
)

export const CreateReleases = (props) => (
  <Create {...props}>
    <SimpleForm>
      <RichTextInput source="description" />
      <DateInput source="released_at" defaultValue={new Date()} />
    </SimpleForm>
  </Create>
)

export const EditReleases = (props) => {
  return (
    <Edit {...props}>
      <SimpleForm>
        <RichTextInput source="description" />
        <DateInput source="released_at" />
      </SimpleForm>
    </Edit>
  )
}
